import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {deleteManyMultiviews, deleteManyMultiviewsFailure, deleteManyMultiviewsSuccess} from './multiview.delete-many.actions';
import {MultiviewsService} from '../../../services/api/multiviews/multiviews.service';
import {Multiview} from '../../../services/api/multiviews/multiview-viewer.model';
import {loadGrids, manyMultiviewsDeleted} from '../../grids/actions/grids.actions';


@Injectable()
export class MultiviewDeleteManyEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteManyMultiviews$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyMultiviews),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<Multiview>[] = ids
            .map((id: UUID): Observable<Multiview> =>
              this.service.delete(id)
            );

          return forkJoin(requests)
            .pipe(
              map(() => deleteManyMultiviewsSuccess({ids: ids})),
              catchError((error: any) => of(deleteManyMultiviewsFailure({error: error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyMultiviewsSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyMultiviewsSuccess),
        tap(() =>
          this.snackBar.open('Multiviews successfully deleted', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) => manyMultiviewsDeleted({ids: data.ids}))
      );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyMultiviewsFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyMultiviewsFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to delete multiviews: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadGrids())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: MultiviewsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
